export { default as isHTMLAnchorElement } from './typeUtils/isHTMLAnchorElement';
export { default as isHTMLImageElement } from './typeUtils/isHTMLImageElement';
export { default as isHTMLElement } from './typeUtils/isHTMLElement';
